import type * as React from 'react';

import { Description, FieldGroup, Label } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../../types';
import { FooterLinksEditor } from './FooterLinksEditor';

/**
 * Panel to configure footer links groups.
 */
export function FooterNavigation(props: SitesCustomizationPanelProps): React.ReactElement {
    const { site, organizationId, settings, setSettings, siteSpaceIds } = props;

    return (
        <FieldGroup>
            <Label>Navigation</Label>
            <Description>
                Choose how your footer looks, add column titles with links below.
            </Description>
            <FooterLinksEditor
                site={site}
                organizationId={organizationId}
                groups={settings.footer.groups}
                onChange={(groups) => {
                    setSettings((prev) => ({
                        ...prev,
                        footer: {
                            ...prev.footer,
                            groups,
                        },
                    }));
                }}
                siteSpaceIds={siteSpaceIds}
            />
        </FieldGroup>
    );
}
